<template>
  <modal
    title="Edit Pending Sale"
    size="side"
    :open="open"
    @close="closeModal"
  >
    <div class="description">
      {{ pendingSale.title }}
    </div>
    <p><span>Price:</span> <b>{{ $filters.currency(pendingSale.price, { full: true }) }}</b></p>

    <card-search
      include-hidden
      placeholder="Assign to a different card"
      @select="setLadderCard"
    />

    <p v-if="switchingCard">
      Switching the card to: {{ switchingCard }}
    </p>

    <date-input
      v-model="pendingSale.date"
      label="Date"
    />

    <select-input
      v-model="pendingSale.platform"
      label="Platform"
      :options="platformOptions"
    />

    <select-input
      v-model="pendingSale.listingType"
      label="Listing Type"
      :options="listingTypeOptions"
    />

    <select-input
      v-model="pendingSale.employee"
      label="Employee"
      :options="employeeOptions"
    />

    <text-area-input
      v-model="pendingSale.employeeNotes"
      label="Employee Notes"
    />

    <template #footer>
      <align small-gap>
        <btn
          :loading="submitting"
          loading-text="Submitting"
          @click="submit"
        >
          Submit
        </btn>

        <btn kind="secondary" @click="closeModal">
          Cancel
        </btn>
      </align>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import clone from 'lodash.clonedeep';
import * as Sentry from '@sentry/vue';

import { SELLING_PLATFORM_OPTIONS, LISTING_TYPE_OPTIONS } from '@cardladder/shared/constants';

import { cardService, saleService } from '@/services';

import CardSearch from '@/cards/CardSearch';

export default {
  components: {
    CardSearch,
  },

  data() {
    return {
      open: false,
      pendingSale: {},
      submitting: false,
      switchingCard: '',
      platformOptions: SELLING_PLATFORM_OPTIONS,
      listingTypeOptions: LISTING_TYPE_OPTIONS,
    };
  },

  mounted() {
    this.$bus.$on('pending-sale-edit', this.handle);
  },

  beforeDestroy() {
    this.$bus.$off('pending-sale-edit', this.handle);
  },

  computed: {
    ...mapState({
      employeeOptions: (state) => state.employeeOptions,
    }),
  },

  methods: {
    handle(pendingSale) {
      this.pendingSale = clone(pendingSale);
      this.open = true;
      this.$store.commit('SET_PENDING_SALES_EDITING', true);
    },

    async submit() {
      this.submitting = true;

      try {
        await saleService.updatePendingSale(this.pendingSale);
        this.$toasted.success('Updated the pending sale!');
        this.$bus.$emit('pending-sale-updated', this.pendingSale);
        this.closeModal();
      } catch (e) {
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    async setLadderCard(card) {
      try {
        const ladderCard = await cardService.getCard(card.id);

        this.pendingSale = {
          ...this.pendingSale,
          cardId: card.id,
          cardImage: card.image,
          cardLabel: card.label,
          condition: ladderCard.condition,
          label: `${ladderCard.player} ${ladderCard.year} ${ladderCard.set} ${ladderCard.variation || ''} ${ladderCard.condition}`,
          marketValue: ladderCard.stats?.marketValue || null,
          guideValue: ladderCard.stats?.guideValue || null,
          eBayQuery: ladderCard.ebayQuery || null,
          newestSaleDate: ladderCard.newestSaleDate || null,
        };

        this.switchingCard = card.label;
      } catch (e) {
        this.$toasted.error('Error updating the pending sale');
      }

      this.showCardSearch = false;
    },

    closeModal() {
      this.switchingCard = '';
      this.pendingSale = {};
      this.open = false;
      this.$store.commit('SET_PENDING_SALES_EDITING', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-search {
  margin: $gp 0;
}
</style>
